<template>
  <div class="address-page">
    <address-stats />
    <div class="features f-r-vc">
      <el-button
        type="primary"
        class="feature-button deep-green-bg"
        @click="addAddress"
      >
        <svg-icon icon-class="plus" class="svg-white-color" />
        Add Address
      </el-button>
    </div>
    <div class="address-list" v-loading="loadingAddress">
      <searchable-table
        :table-headers="AddressTableHeaders"
        :table-data="addressPage"
        :search-params="searchForm"
        :search-param-change="searchParamChange"
        :has-actions="true"
      >
        <template v-slot:actions="props">
          <el-button
            size="small"
            type="text"
            @click="goToAddressDetail(props.row.id)"
          >
            Detail
          </el-button>
        </template>
      </searchable-table>
    </div>
    <address-new ref="newAddress"></address-new>
  </div>
</template>

<script>
import set from 'lodash/set'
import cloneDeep from 'lodash/cloneDeep'
// mixins
import { pageJumps } from '@/core/mixin/pages'
// apis
import { queryAddress } from '@/api/address'
// model
import {
  AddressTableHeaders,
  AddressSearchForm,
  AddressSearchParamsWrapUp
} from '@/core/models/address'
// components
import SearchableTable from '@/components/common/SearchableTable.vue'
import AddressNew from '@/components/address/AddressNew.vue'
import AddressStats from '@/components/address/AddressStats.vue'

export default {
  name: 'AddressPage',
  components: {
    SearchableTable,
    AddressNew,
    AddressStats
  },
  mixins: [pageJumps],
  data() {
    return {
      AddressTableHeaders,
      searchForm: cloneDeep(AddressSearchForm),
      loadingAddress: true,
      addressPage: null
    }
  },
  methods: {
    addAddress() {
      this.$refs.newAddress.open()
    },
    searchParamChange(key, path, value) {
      set(this.searchForm[key], path, value)
      this.searchAddress()
    },
    async searchAddress() {
      const searchForm = AddressSearchParamsWrapUp(this.searchForm)
      this.loadingAddress = true
      const page = await queryAddress(searchForm)
      this.$set(this, 'addressPage', page)
      this.loadingAddress = false
    }
  },
  mounted() {
    this.searchAddress()
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.address-page {
  width: 100%;
  overflow-x: hidden;

  @extend .f-c;

  .features {
    @extend .global-margin;
  }

  .address-list {
    @extend .global-margin;
    @extend .shadow-level-three;

    border-radius: $home-card-border-radius;
    padding: $home-card-padding-y $home-card-padding-x;
    background-color: white;
  }
}
</style>
